// Custom Elements to import
import "../components/discussion-share/DiscussionShare";
import { CCCDiscussionShare } from "../components/discussion-share/DiscussionShare";
import { DiscussionType } from "../core/interfaces/Discussion";
import { getDomElement } from "../core/utilities";

export class DiscussionShareButtonController {
  $anchor: HTMLElement = null;
  $component: CCCDiscussionShare = null;

  init(anchor: string, type = DiscussionType.discussion): void {
    console.debug("Discussion Share Button - INIT");
    if (this.$anchor === null) {
      this.$anchor = getDomElement(anchor);
    }
    if (this.$anchor) {
      if (getDomElement("ccc-discussion-share")) {
        return;
      }
      if (this.$component === null)
        this.$component = document.createElement(
          "ccc-discussion-share"
        ) as CCCDiscussionShare;
      this.$component.setAttribute("type", type);

      console.debug("Discussion Share Button - ", this.$component);

      this.$anchor.prepend(this.$component);
    } else {
      console.error(
        `Discussion Share Button - ${anchor} element not found in DOM`
      );
    }
  }
}
